export const PROCESS = {
    APPROVAL: "After wallet approval, your transaction will be finished shortly.",
    TRANSFER: "Your transaction will be finished shortly",
    SIGNATURE: "Waiting for signature...",
    NO_LISTED_COSMETICS: "You don’t have any listed items yet!",
    NO_BAZAAR_LISTED_COSMETICS: "No KOMPETE items for sale",
    NO_ACTIVITY: "You don’t have any activity yet!",
    NO_COSMETICS: "You don’t own any KOMPETE cosmetics.",
    WALLET_CONFIRM: "Please sign to confirm your wallet",
}

export const INFO = {
    NFT_TRANSFER: "infoNftTransfer",
    OFFER_CREATE: "infoOfferCreate",
    LISTING_CREATE: "infoListingCreate",
    LISTING_EDIT: "infoListingEdit"
}

export const WARNING = {
    LISTING_CANCEL: "warningListingCancel",
    OFFER_CANCEL: "warningOfferCancel",
    NFT_TRANSFER: "warningNftTransfer",
    LISTING_PURCHASE: "warningListingPurchase"
}